module.exports = __webpack_public_path__ + "static/media/IconeMelhor2.42a1ea7f.png";